// extracted by mini-css-extract-plugin
export var footer = "_pl-0";
export var inherit = "_pl-1";
export var input = "_pl-2";
export var modalContent = "_pl-3";
export var quillEditor = "_pl-4";
export var subtitle = "_pl-5";